import React, { useState, useRef, useEffect } from 'react';
import { Button, Dropdown } from 'react-bootstrap';

const DayOperationsMenu = ({ 
  day, 
  onCopyDay, 
  onClearDay, 
  onClearMeal,
  hasRecipes,
  meals = ['Breakfast', 'Lunch', 'Dinner', 'Snack', 'Appetizer', 'Dessert', 'Other'],
  currentPlanType = 'current'
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    if (showMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showMenu]);

  if (!hasRecipes && day === 'None') {
    return null;
  }

  return (
    <div className="day-operations-menu" ref={menuRef}>
      <Dropdown show={showMenu} onToggle={setShowMenu}>
        <Dropdown.Toggle 
          variant="link" 
          size="sm" 
          className="day-menu-toggle"
          id={`day-menu-${day}`}
        >
          <i className="fas fa-ellipsis-v"></i>
        </Dropdown.Toggle>

        <Dropdown.Menu align="end">
          {hasRecipes && (
            <>
              {onCopyDay && (
                <>
                  <Dropdown.Item onClick={() => onCopyDay(day)}>
                    <i className="fas fa-copy me-2"></i>
                    Copy Day's Plan
                  </Dropdown.Item>
                  
                  <Dropdown.Divider />
                </>
              )}
              
              <Dropdown.Item 
                onClick={() => onClearDay(day)}
                className="text-danger"
              >
                <i className="fas fa-trash-alt me-2"></i>
                Clear Entire Day
              </Dropdown.Item>
              
              <Dropdown.Divider />
              
              <Dropdown.Header>Clear Specific Meal</Dropdown.Header>
              {meals.map(meal => (
                <Dropdown.Item 
                  key={meal}
                  onClick={() => onClearMeal(day, meal)}
                  className="text-warning small"
                >
                  <i className="fas fa-times me-2"></i>
                  Clear {meal}
                </Dropdown.Item>
              ))}
            </>
          )}
          
          {!hasRecipes && day !== 'None' && (
            <Dropdown.Item disabled>
              No recipes to manage
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default DayOperationsMenu;